import { FC, Modal, useMemo} from 'external/react'
import useParent from 'context/parent-context/hook'
import PackageModalHeader from './PackageModalHeader'
import {
	Elements,
	CardElement,
	useStripe,
	useElements,
  loadStripe,
  stripeOptions
} from 'external/stripe';
import { isEmpty } from 'utilities/text';
import { clsx } from 'external/clsx';
import { notifyError, notifySuccess } from 'components/Notify';
import { paymentService } from 'services/payment.service';

type ChangePaymentMethodProps = {
  handleClose: () => void 
}

type UpdatePaymentMethodProps = {
  subscription: string
  index: number | false
  handleClose: (index: number| false) => void
}

const stripePromise = loadStripe()

const UpdatePaymentMethod:FC<UpdatePaymentMethodProps> = props => {

  const {handleClose, index, subscription} = props

	const stripe = useStripe();
	const elements = useElements();
  const {update, state: {modals: {changePaymentMethod: {error}}}} = useParent()

	async function handleSubmit (event) {

		event.preventDefault()
		if (!stripe || !elements) return
		const card = elements.getElement(CardElement);
    if (card === null) return
		const { error, paymentMethod } = await stripe.createPaymentMethod({type: 'card', card});

		if (error && !isEmpty(error)) {
      update({modals: {changePaymentMethod: {error: {$set: error.message || ''}}}})
			return
		}

		try {
			const response = await paymentService.updatePaymentMethod({paymentMethod, subscription});

			if (response.data.success) {
				notifySuccess('Método de pago actualizado exitosamente');
        update({payments: {refreshes: {$apply: i => i + 1}}})
				handleClose(index)
			} else {
				notifyError(
					'Error al actualizar el método de pago, intentalo mas tarde o con otro método de pago.',
				)
			}
		} catch (error) {
      console.log(error)
		}
	}

	return (
		<>
			<CardElement className='stripe-input' />
				<div className={clsx('d-none', {'d-block': !isEmpty(error)})} style={{ color: 'red' }}>{error}</div>
        <br />
        <div className='text-right'>
          <button className='btn btn-light' onClick={() => handleClose(index)}>
            Cancelar
          </button>
          <button className='btn btn-primary ml-2' onClick={(e) => handleSubmit(e)} disabled={!stripe}>
            Añadir tarjeta
          </button>
			</div>
		</>
	)
}


const ChangePaymentMethod:FC<ChangePaymentMethodProps> = props => {

  const {handleClose} = props

  const {state: {payments, changePaymentMethodIndex: index}} = useParent()
  const [show, payment] = useMemo(() => index === false
    ? [false, {} as any]
    : [true, payments.items[index]]
  , [index])

  const {subscription} = payment

  return (
    <Modal show={show} onHide={handleClose} size='lg' centered >
      <PackageModalHeader index={index} />
      <Modal.Body>
					<label>Reemplazar método de pago</label>
					<Elements stripe={stripePromise} options={stripeOptions}>
						<UpdatePaymentMethod
              index={index}
							subscription={subscription}
							handleClose={handleClose}
						/>
					</Elements>
      </Modal.Body>
      <Modal.Footer>
      </Modal.Footer>
    </Modal>
  )
}


export {ChangePaymentMethod as default}